// extracted by mini-css-extract-plugin
module.exports = {"perks":"AboutSectionPerks-module_perks_9754a","perksButton":"AboutSectionPerks-module_perksButton_d6b2b"};